import { MicrosoftResellerDetails } from '../../../admin/modules/resaleAuthorizations/reducer'
import {
  AzureOfferPlan,
  AzurePriceInputOption,
  AzurePricingType,
  EulaType,
  RecurrentPriceModeType,
} from '../privateOffer/reducer'
import { FailedErrorMessage } from '../receivedResellerAuthorization/reducer'
import { MsftCombineFormActionTypes } from './action'
import { Reducer } from 'redux'

export enum MsftCombinedFormStatus {
  DRAFT = 'DRAFT',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  RESALE_AUTHORIZATION_CREATION_IN_PROGRESS = 'RESALE_AUTHORIZATION_CREATION_IN_PROGRESS',
  RESALE_AUTHORIZATION_CREATED = 'RESALE_AUTHORIZATION_CREATED',
  RESALE_AUTHORIZATION_CREATION_FAILED = 'RESALE_AUTHORIZATION_CREATION_FAILED',
  RESALE_AUTHORIZATION_ACCEPTED = 'RESALE_AUTHORIZATION_ACCEPTED',
  CHANNEL_OFFER_CREATION_IN_PROGRESS = 'CHANNEL_OFFER_CREATION_IN_PROGRESS',
  CHANNEL_OFFER_CREATED = 'CHANNEL_OFFER_CREATED',
  CHANNEL_OFFER_CREATION_FAILED = 'CHANNEL_OFFER_CREATION_FAILED',
  CHANNEL_OFFER_EXTENDED_TO_BUYER = 'CHANNEL_OFFER_EXTENDED_TO_BUYER',
  CHANNEL_OFFER_ACCEPTED = 'CHANNEL_OFFER_ACCEPTED',
}

export type MsftCombinedFormAuditJson = {
  draft: string
  resaleAuthorizationCreationInProgress: string
  resaleAuthorizationCreated: string
  resaleAuthorizationCreationFailed: string
  resaleAuthorizationAccepted: string
  channelOfferCreationInProgress: string
  channelOfferCreated: string
  channelOfferCreationFailed: string
  channelOfferExtendedToBuyer: string
  channelOfferAccepted: string
  approved: string
  rejected: string
}

export interface MsftCombinedFormDraftOffer {
  mppoName: string
  privateOfferType: string
  offerPricingType: string
  variableStartDate: boolean
  existingContractRenewal: boolean
  offerStartDate: string
  offerExpirationDate: string
  acceptBy: string
  preparedBy: string
  eulaFiles: string[]
  beneficiaryId: string
  companyName: string
  eulaType: EulaType
  cloudProductId: string
  labraProductId: string
  plans: AzureOfferPlan[]
  resellerEulaFiles: string[]
  resellerDetails?: MicrosoftResellerDetails[]
  mppoDescription: string
}

export interface MsftCombinedFormState {
  id: string | null
  azureMppoId: string | null
  labraIsvId: string
  labraResellerId: string
  draftOffer: MsftCombinedFormDraftOffer
  status?: MsftCombinedFormStatus
  statusLogs?: MsftCombinedFormAuditJson
  externalId?: string
  externalMetadata?: Record<string, unknown>
  errorDetails?: {
    errors?: FailedErrorMessage[]
  }
}

export const initialState: MsftCombinedFormState = {
  id: null,
  azureMppoId: null,
  labraIsvId: '',
  labraResellerId: '',
  draftOffer: {
    acceptBy: '',
    companyName: '',
    beneficiaryId: '',
    mppoName: '',
    mppoDescription: '',
    eulaFiles: [],
    eulaType: 'STANDARD' as EulaType,
    existingContractRenewal: false,
    cloudProductId: '',
    labraProductId: '',
    plans: [
      {
        displayName: '',
        planId: '',
        offerPricingType: 'saasNewCustomizedPlans',
        description: '',
        labraPlanId: '',
        discountPercentage: undefined,
        markupPercentage: undefined,
        buyerPrice: undefined,
        discountType: 'absolute' as AzurePricingType,
        pricing: {
          recurrentPrice: {
            priceInputOption: 'usd' as AzurePriceInputOption,
            prices: [],
            userLimits: {
              min: undefined,
              max: undefined,
            },
            recurrentPriceMode: 'flatRate' as RecurrentPriceModeType,
          },
          customMeters: {
            meters: {},
            priceInputOption: 'usd' as AzurePriceInputOption,
          },
        },
      },
    ],
    resellerEulaFiles: [],
    privateOfferType: 'multipartyPromotionOriginator',
    offerPricingType: 'newCustomizedPlans',
    variableStartDate: true,
    offerStartDate: '',
    offerExpirationDate: '',
    preparedBy: '',
  },
  status: MsftCombinedFormStatus.DRAFT,
  statusLogs: undefined,
  errorDetails: {
    errors: [],
  },
}

type ActionType =
  | {
      type: MsftCombineFormActionTypes.SET_COMBINED_FORM_DATA
      payload: MsftCombinedFormState
    }
  | {
      type: MsftCombineFormActionTypes.CLEAR_COMBINED_FORM_DATA
    }

export const reducer: Reducer<MsftCombinedFormState, ActionType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case MsftCombineFormActionTypes.SET_COMBINED_FORM_DATA: {
      return {
        ...state,
        ...action.payload,
      }
    }

    case MsftCombineFormActionTypes.CLEAR_COMBINED_FORM_DATA: {
      return {
        ...initialState,
      }
    }

    default:
      return state
  }
}
